// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FormatPainterFilledSvg from "@ant-design/icons-svg/es/asn/FormatPainterFilled";
import AntdIcon from '../components/AntdIcon';

var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterFilledSvg
  }));
};

FormatPainterFilled.displayName = 'FormatPainterFilled';
export default React.forwardRef(FormatPainterFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FormatPainterFilled.js
// module id = 1215
// module chunks = 0